/**
 * OnMyWay protection programs — sales collateral names/taglines.
 * Employee training certificates map 1:1 to these program IDs.
 */
export const ONMYWAY_PLATFORM_FEATURES = [
  {
    id: "archie-securepath-personal-protection",
    name: "Archie+ SecurePath",
    tagline: "Real Person, Real Time, Real Protection.",
  },
  {
    id: "workplace-emergency-panic-response",
    name: "Workplace Emergency Dispatch",
    tagline: "Quick response when employees need help.",
  },
  {
    id: "ridewatch-transportation-safety",
    name: "RideWatch / Travel Protection Program",
    tagline:
      "Monitored with Real People, documented, and backed by safety protocols.",
  },
  {
    id: "mental-health-workplace-wellness",
    name: "Mental Health Shield Program",
    tagline: "Support when stress or crisis requires help or immediate dispatch.",
  },
  {
    id: "personal-safety-travel-concierge",
    name: "Employee Violence Response System",
    tagline: "Fast, safe response to threatening situations.",
  },
  {
    id: "lone-worker-remote-protection",
    name: "Remote / Lone Worker Lifeline",
    tagline:
      "Protection for Sales / Remote workers and employees working alone.",
  },
  {
    id: "safety-in-motion-protection",
    name: "Safety In-Motion Program",
    tagline: "Protection from Slips and Falls, AI + Real Person Dispatch",
  },
  {
    id: "defensive-driving-distracted",
    name: "OnMyWay Drive Program",
    tagline:
      "Distracted Driving Protection for all employees anytime they get behind the wheel.",
  },
  {
    id: "safety-engagement-participation",
    name: "OnMyWay One – Reporting and Repository",
    tagline: "Simple Reporting / Safety Program and Compliance Certification.",
  },
  {
    id: "verifyai-digital-identity-protection",
    name: "VerifyAI Cybersecurity",
    tagline:
      "Identify manipulated media and digital impersonation and risks that are attached.",
  },
] as const;

export const EMPLOYEE_FEATURE_CERT_IDS = ONMYWAY_PLATFORM_FEATURES.map(
  (f) => f.id
);
